<script>
    var userInfo = {
        "accountid": 0,
        'name': '',
        'passcode': '',
        'nickname': '',
    };
    var lanCode = 'th';
    var lanArr = [];
    var deviceid = '';
    var apiAesKey = '';
    var apiUrl = '';
    var lineCustomer = '';
    var lanLocal = [];

    export default {
        userInfo, lanCode, lanArr, deviceid, apiAesKey, apiUrl, lineCustomer, lanLocal
    }
</script>


// WEBPACK FOOTER //
// src/Global.vue